(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayudra-footer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Only enable accordion on mobile devices
    function isMobile() {
      return window.innerWidth <= 766;
    }

    const accordionToggles = document.querySelectorAll('.ayudra-footer__accordion-toggle');
    
    accordionToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        // Only process accordion on mobile
        if (!isMobile()) {
          return;
        }

        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const accordionContent = this.nextElementSibling;
        
        if (!accordionContent) {
          return;
        }
        
        // Close all other accordions
        accordionToggles.forEach(function(otherToggle) {
          if (otherToggle !== toggle) {
            otherToggle.setAttribute('aria-expanded', 'false');
            const otherContent = otherToggle.nextElementSibling;
            if (otherContent) {
              otherContent.style.maxHeight = '0';
            }
          }
        });
        
        // Toggle current accordion
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          accordionContent.style.maxHeight = '0';
        } else {
          this.setAttribute('aria-expanded', 'true');
          // Calculate actual height
          accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        }
      });
    });

    // Reset accordions on window resize to desktop
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (!isMobile()) {
          // Reset all accordions on desktop
          accordionToggles.forEach(function(toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            const content = toggle.nextElementSibling;
            if (content) {
              content.style.maxHeight = '';
            }
          });
        }
      }, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Accordion functionality for collection SEO footer
  document.addEventListener('click', function(e) {
    const toggle = e.target.closest('[data-accordion-toggle]');
    if (!toggle) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const targetId = toggle.getAttribute('data-target');
    const content = document.getElementById(targetId);
    
    if (!content) return;
    
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      // Close accordion
      toggle.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.style.maxHeight = '0';
      content.style.overflow = 'hidden';
    } else {
      // Open accordion
      toggle.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      // Calculate actual content height and set to that plus buffer
      const contentHeight = content.scrollHeight;
      content.style.maxHeight = (contentHeight + 50) + 'px';
      content.style.overflow = 'visible';
      // After transition, set to very large value to ensure all content shows
      setTimeout(function() {
        if (content.getAttribute('aria-hidden') === 'false') {
          content.style.maxHeight = '99999px';
          content.style.overflow = 'visible';
        }
      }, 500);
    }
  });
  
  // Initialize accordion content state
  function initAccordionState() {
    const contents = document.querySelectorAll('.accordion-section__content');
    contents.forEach(function(content) {
      content.style.maxHeight = '0';
      content.style.overflow = 'hidden';
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionState);
  } else {
    initAccordionState();
  }

  } catch(e) { console.error(e); }
})();
})();
